<template>
  <div class="plan-name-and-suggestions-page">
    <div class="headline">התוכניות הגדולות שלי</div>
    <div class="image-container">
      <img class="image" :src="require(`@/assets/plan-ahead/icons/${image}.svg`)"/>
    </div>
    <div class="content-container">
      <plan-suggestions class="suggestions" @change="setNameAndType" :initialNameAndType="{name, type}"/>
      <riseup-button class="button" :disabled="!name" title="הבא" size="slim" variant="neutral" :action="done" />
    </div>
  </div>
</template>

<script>
import BaseUi from 'base-ui';
import { mapState } from 'vuex';
import Segment from '@/Segment';
import PlansIconsMap from '../plans-constanst';
import PlanSuggestions from '../PlanSuggestions';

export default {
  name: 'PlanNameAndSuggestionsPage',
  components: {
    PlanSuggestions,
    RiseupButton: BaseUi.RiseupButton,
  },
  data() {
    return {
      name: '',
      type: undefined,
    };
  },
  created() {
    if (this.currentPlan.name) {
      this.name = this.currentPlan.name;
      this.type = this.currentPlan.type;
    }
  },
  computed: {
    ...mapState('planAhead', ['currentPlan', 'suggestions']),
    image() {
      return PlansIconsMap[this.type] || 'general';
    },
  },
  methods: {
    setNameAndType(newValue) {
      this.name = newValue.name;
      this.type = newValue.type;
    },
    done() {
      const usedSuggestions = this.suggestions.map(s => s.name).includes(this.name);
      Segment.trackUserInteraction('PlanAhead_Flow_NamePage_NextClicked', { usedSuggestions });
      this.$emit('done', { name: this.name, type: this.type });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.plan-name-and-suggestions-page {
  overflow: auto;
  height: 100%;

  .headline {
    height: 57px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    padding-right: 24px;
  }

  .image-container {
    height: 226px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    background: $riseup_gray_disabled;

    .image {
      height: 150px;
    }
  }

  .content-container {
    margin: 0 24px;

    .suggestions {
      margin-bottom: 50px;
    }
  }

  .button {
    margin-bottom: 20px;
  }
}

</style>
